export default "__VITE_ASSET__kbSDU4fb__"